webpackJsonp([7,47],{

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import papaparse from 'papaparse'

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      droppedFiles: null,
      dragOver: false,
      sendEmails: false,
      sendingEmail: false,
      alert: {
        status: false,
        message: '',
        type: 'warning'
      },
      loadingCSV: false,
      btnLoading: false,
      results: [],
      headers: [{
        text: 'Company Name',
        align: 'left',
        sortable: false,
        value: 'companylegalname'
      }, {
        text: 'Company Description',
        align: 'left',
        sortable: false,
        value: 'companydescription'
      }, {
        text: 'Email Address',
        align: 'left',
        sortable: false,
        value: 'emailaddress'
      }]
    };
  },
  methods: {
    pickFile: function pickFile() {
      this.$refs.csvImport.click();
    },
    handleFile: function handleFile() {
      var _this = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pick';
      this.alert.status = false;
      this.dragOver = false;
      this.alert.status = false;
      this.results = [];
      var file;

      if (type === 'drop') {
        file = this.droppedFiles[0];
      } else if (type === 'pick') {
        file = this.$refs.csvImport.files[0];
      }

      if (file) {
        if (file.type.indexOf('csv') < 0) {
          this.alert = {
            type: 'error',
            status: true,
            message: 'Please upload a valid CSV file.'
          };
          return;
        }

        this.loadingCSV = true;
        return window.Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          greedy: true,
          worker: true,
          preview: 100,
          complete: function complete(results) {
            _this.loadingCSV = false;

            if (results.data.length > 100) {
              _this.alert = {
                type: 'error',
                status: true,
                message: 'Required limit: You can only import 100 items at a time'
              };
              return;
            }

            if (!results.meta.fields.includes('companylegalname') || !results.meta.fields.includes('dunsnumber')) {
              _this.alert = {
                type: 'error',
                status: true,
                message: 'Please upload a valid CSV file with the accepted headers. companylegalname, dunsnumber'
              };
            }

            _this.results = _this._.map(results.data, function (v) {
              var omitted = _this._.omit(v, ['_id', 'id']);

              var transformed = _this._.mapValues(omitted, function (fieldValue) {
                if (fieldValue === 'TRUE') {
                  return true;
                } else if (fieldValue === 'FALSE') {
                  return false;
                } else {
                  return fieldValue;
                }
              });

              return transformed;
            }).filter(function (val) {
              return val.companylegalname;
            }).map(function (val) {
              return _objectSpread(_objectSpread({}, val), {}, {
                datasource: 'Exchange_app',
                dirviewable: val.dunsnumber.length === 9
              });
            });
          }
        });
      }
    },
    saveImported: function saveImported() {
      var _this2 = this;

      this.btnLoading = true;
      var uri = 'https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?checkclientid=false';
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(uri, this.results).then(function (res) {
        _this2.btnLoading = false;
        _this2.alert = {
          type: 'success',
          status: true,
          message: 'Companies imported successfully.'
        };
      }).catch(function () {
        _this2.btnLoading = false;
        _this2.alert = {
          type: 'error',
          status: true,
          message: 'Something went wrong while saving the contacts.'
        };
      });
    },
    resetForm: function resetForm() {
      this.btnLoading = false;
      this.companyForm = {
        companylegalname: null,
        emailaddress: null,
        addressline1: null,
        addressline2: null,
        city: null,
        county: null,
        latitude: null,
        longitude: null,
        state: null,
        zip: null
      };
      this.results = [];
    }
  }
};

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_KendoTable_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_KendoTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_KendoTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_CompanyModal_vue__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_CompanyModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Components_CompanyModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_DeleteCompanyModal_vue__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_DeleteCompanyModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Components_DeleteCompanyModal_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    KendoTable: __WEBPACK_IMPORTED_MODULE_3__components_KendoTable_vue___default.a,
    CompanyModal: __WEBPACK_IMPORTED_MODULE_4__Components_CompanyModal_vue___default.a,
    DeleteCompanyModal: __WEBPACK_IMPORTED_MODULE_5__Components_DeleteCompanyModal_vue___default.a
  },
  data: function data() {
    return {
      search: "",
      companies: [],
      tablePagination: {},
      totalData: 0,
      tableLoading: true,
      deleteCompanyModalDialog: false,
      companyModalDialog: false,
      companyModalReadonly: false,
      companyId: null,
      datasource: "USASpending.Gov.Exchange_app.community-exchange",
      datasources: [{
        text: "All",
        value: "Community_app.GTPAC_Neoserra.USASpending.Gov.Exchange_app.community-exchange"
      }, {
        text: "GTPAC Companies",
        value: "GTPAC_Neoserra.Community_app.community-exchange"
      }, {
        text: "Exchange Companies",
        value: "USASpending.Gov.Exchange_app.community-exchange"
      }, {
        text: "Community & Exchange Companies",
        value: "community-exchange"
      }],
      headers: [{
        text: "Company",
        value: "companylegalname"
      }, {
        text: "Address",
        value: "streetaddress"
      }, {
        text: "Actions",
        value: "actions"
      }],
      link: "https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?datasource=USASpending.Gov.Exchange_app.community-exchange&sort[0][field]=companylegalname&sort[0][dir]=ASC"
    };
  },
  watch: {
    $route: {
      deep: true,
      handler: function handler(val) {
        var hash = val.hash.replace("#action=", "");
        var type = hash.slice(0, 4);
        var companyId = hash.slice(5, hash.length);

        if (type === "view" || type === "edit") {
          this.companyModalReadonly = type === "view";
          this.companyId = companyId;
          this.companyModalDialog = true;
          return;
        }

        type = hash.slice(0, 6);
        companyId = hash.slice(7, hash.length);

        if (type === "delete") {
          this.companyId = companyId;
          this.deleteCompanyModalDialog = true;
        }
      }
    },
    search: function search(val) {
      if (val) {
        this.link = encodeURI("https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?companylegalname=".concat(val, "&datasource=").concat(this.datasource));
        return;
      }

      this.link = encodeURI("https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?datasource=".concat(this.datasource));
      return;
    },
    datasource: function datasource(val) {
      if (this.search) {
        this.link = encodeURI("https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?companylegalname=".concat(this.search, "&datasource=").concat(val));
        return;
      }

      this.link = encodeURI("https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?datasource=".concat(val));
    },
    link: {
      immediate: true,
      handler: function handler(val) {
        return this.getCompanies(val);
      }
    },
    tablePagination: {
      deep: true,
      immediate: true,
      handler: function handler(pagination) {
        this.getCompanies(this.link);
      }
    }
  },
  computed: {
    query: function query() {
      return this.link;
    }
  },
  methods: {
    editCompany: function editCompany(company) {
      var companyId = company._id;
      var type = "edit";
      window.location.hash = "#action=".concat(type, "-").concat(companyId);
    },
    viewCompany: function viewCompany(company) {
      var companyId = company._id;
      var type = "view";
      window.location.hash = "#action=".concat(type, "-").concat(companyId);
    },
    deleteCompany: function deleteCompany(company) {
      var companyId = company._id;
      var type = "delete";
      window.location.hash = "#action=".concat(type, "-").concat(companyId);
    },
    getCompanies: function getCompanies(link) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this$tablePagination, rowsPerPage, page, params, _yield$axios$get, data;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.tableLoading = true;
                _this$tablePagination = _this.tablePagination, rowsPerPage = _this$tablePagination.rowsPerPage, page = _this$tablePagination.page;
                params = {
                  take: rowsPerPage || 15,
                  page: page || 1,
                  skip: rowsPerPage ? rowsPerPage * (parseInt(page) - 1) : 0
                };
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(link, {
                  params: params
                });

              case 6:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;
                _this.companies = data.data;
                _this.totalData = data.total;
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

              case 14:
                _context.prev = 14;
                _this.tableLoading = false;
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12, 14, 17]]);
      }))();
    },
    refreshTable: function refreshTable() {
      this.getCompanies(this.link);
    },
    deleteCompanyAction: function deleteCompanyAction(id) {
      var _this2 = this;

      var uri = "https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2/".concat(id);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(uri).then(function () {
        _this2.closeModal("deleteCompanyModalDialog");

        _this2.$store.dispatch("triggerSnackbar", {
          text: "Company deleted successfully.",
          active: true,
          timeout: 7000
        });
      }).catch(function () {
        _this2.link = _this2.link;

        _this2.closeModal("deleteCompanyModalDialog");

        _this2.$store.dispatch("triggerSnackbar", {
          text: "An error occured while deleting the company. Please Try again later.",
          active: true,
          timeout: 8000
        });
      });
    },
    closeModal: function closeModal(val) {
      window.location.hash = "";
      this[val] = false;
      this.getCompanies(this.link);
    }
  }
};

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Company_UpdateCompany__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Company_UpdateCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Company_UpdateCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_ImportCompany__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_ImportCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Company_ImportCompany__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AdminSideBarMenu: __WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar___default.a,
    UpdateCompany: __WEBPACK_IMPORTED_MODULE_1__Company_UpdateCompany___default.a,
    ImportCompany: __WEBPACK_IMPORTED_MODULE_2__Company_ImportCompany___default.a
  },
  methods: {
    isSelectedTab: function isSelectedTab(tabName) {
      var urlSection = this.$route.params.id || 'general-settings';
      return tabName === urlSection;
    }
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        'h1': 'Update Company',
        'title': 'Update Company',
        'description': 'Update Company',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
  }
};

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  props: ["readonly", "id", "show", "refreshTable"],
  data: function data() {
    return {
      pickDateMenu: false,
      tempCompanyLogo: null,
      tempCompanyLogoFile: null,
      statementFileName: null,
      companySettingsLoading: false,
      naicscodes: [],
      psccodes: [],
      additionalNaicscodes: [],
      additionalPsccodes: [],
      updatedCompanyFields: [],
      naicsSearch: "",
      pscSearch: "",
      additionalNaicsSearch: "",
      additionalPscSearch: "",
      loading: false,
      companySettingsForm: {
        companylegalname: "",
        addressline1: "",
        addressline2: "",
        city: "",
        county: "",
        zip: "",
        state: "GA",
        businesswebsite: "",
        phonenumber: "",
        email: "",
        companydescription: "",
        dunsnumber: "",
        cagecode: "",
        companycertifications: [],
        fedcontractor: "",
        fedcontractortype: "",
        companyprimaryindustry: "",
        primarypsccode: "",
        securityclearance: "",
        smallbusiness: false,
        womanowned: false,
        additionalpsccodes: [],
        minorityowned: false,
        certified8a: false,
        additionalnaicscodes: [],
        veteranowned: false,
        primarynaicscode: [],
        specialties: "",
        capabilities: "",
        companylogo: "",
        capabilitiesstatement: ""
      },
      certifications: ["Total Small Business", "Competitive 8(a)", "Veteran-Owned Small Business", "Service-Disabled Veteran-Owned Small Business", "Woman Owned Small Business", "Economically Disadvantaged Woman Owned Small Business", "Indian Small Business Economic Enterprises", "Indian Economic Enterprises", "Emerging Small Business", "Partial Small Business", "Very Small Business", "Partial HBCU / MI", "Total HBCU / MI"],
      primaryIndustry: ["Aerospace", "Agribusiness", "Construction", "Defense", "Finance", "Information Technology", "Logistics", "Manufacturing", "R&D", "Retail", "Service", "Surplus Dealer", "Telecommunications", "Wholesale", "Other"]
    };
  },
  computed: {
    company: function company() {
      var details = this.$store.getters.getCompanyDetails; // if (details.id) {
      //   this.getCompanySetting(details.id)
      // }

      return details;
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        return this.getCompanySetting(this.id);
      }
    },
    naicsSearch: function naicsSearch(val) {
      val && this.queryNaicsCodes(val);
    },
    additionalNaicsSearch: function additionalNaicsSearch(val) {
      val && this.queryAdditionalNaicsCodes(val);
    },
    additionalPscSearch: function additionalPscSearch(val) {
      val && this.queryAdditionalPscCodes(val);
    },
    pscSearch: function pscSearch(val) {
      val && this.queryPscCodes(val);
    },
    companySettingsForm: {
      handler: function handler(newVal) {
        if (this.watchCompanySettingsForm) {
          this.updatedCompanyFields = this._.union(this._.cloneDeep(this.updatedCompanyFields), ["companycertifications", "additionalpsccodes", "additionalnaicscodes"], this.getUpdatedCompanyFields(this.oldCompanySettings, newVal));
          this.oldCompanySettings = this._.cloneDeep(newVal);
          return;
        }

        this.watchCompanySettingsForm = true;
        this.oldCompanySettings = this._.cloneDeep(newVal);
      },
      deep: true
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      if (typeof date === "number") {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date(date)).format("YYYY-MM-DD"); // eslint-disable-next-line valid-typeof
      } else if (typeof date === "str" && Number(date)) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date(Number(date))).format("YYYY-MM-DD");
      } else {
        return date;
      }
    },
    close: function close() {
      this.$emit("closeModal", "companyModalDialog");
    },
    updateCompanySettings: function updateCompanySettings() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var companyId, api, updates, i, _this$companySettings, addressline1, addressline2, city, state, zip, streetaddress, url;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                companyId = _this.id;
                api = "https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2";
                updates = {
                  _id: companyId
                };

                for (i = 0; i < _this.updatedCompanyFields.length; i++) {
                  if (_this.updatedCompanyFields[i] === "companycertifications" || _this.updatedCompanyFields[i] === "additionalnaicscodes" || _this.updatedCompanyFields[i] === "additionalpsccodes") {
                    updates[_this.updatedCompanyFields[i]] = _this.companySettingsForm[_this.updatedCompanyFields[i]].join(",");
                  } else {
                    updates[_this.updatedCompanyFields[i]] = _this.companySettingsForm[_this.updatedCompanyFields[i]];
                  }
                }

                _this.$store.dispatch("triggerSnackbar", {
                  text: "Updating company settings",
                  active: true
                });

                _this$companySettings = _this.companySettingsForm, addressline1 = _this$companySettings.addressline1, addressline2 = _this$companySettings.addressline2, city = _this$companySettings.city, state = _this$companySettings.state, zip = _this$companySettings.zip;
                streetaddress = [addressline1, addressline2, city, state, zip].filter(function (v) {
                  return v;
                }).join(", ");
                updates.streetaddress = streetaddress;

                if (updates.profilesubmissiondate) {
                  updates.profilesubmissiondate = new Date(updates.profilesubmissiondate).getTime();
                }

                if (!_this.tempCompanyLogoFile) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return _this.uploadLogo(_this.id);

              case 12:
                url = _context.sent;
                updates.companylogo = url;

              case 14:
                if (!_this.tempCompanyStatementFile) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return _this.uploadStatement(_this.id);

              case 17:
                url = _context.sent;
                updates.capabilitiesstatement = url;

              case 19:
                if (!Object.keys(updates).length) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(api, updates).then(function (res) {
                  _this.$firebase.database().ref("/companies/".concat(companyId)).update(_this._.pick(updates, ["companylegalname", "companylogo", "capabilitiesstatement", "profilesubmitted", "profilesubmissiondate", "submitby", "submitdate"]));

                  _this.$store.dispatch("triggerSnackbar", {
                    text: "Updated successfully!",
                    active: true
                  });

                  _this.updatedCompanyFields = ["companycertifications", "additionalpsccodes", "additionalnaicscodes"];

                  _this.getCompanySetting(companyId);

                  _this.refreshTable(companyId);
                }));

              case 23:
                _this.$store.dispatch("triggerSnackbar", {
                  text: "You haven't made any updates yet.",
                  active: true
                });

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pickFile: function pickFile(key) {
      this.$refs[key].click();
    },
    setTempCompanyLogo: function setTempCompanyLogo() {
      var self = this;
      var reader = new window.FileReader();
      var blob = this.$refs.companylogo.files[0];
      this.tempCompanyLogoFile = blob;

      reader.onload = function (e) {
        self.tempCompanyLogo = reader.result;
      };

      reader.readAsDataURL(blob);
    },
    setTempCompanyStatement: function setTempCompanyStatement() {
      var blob = this.$refs.companystatement.files;
      this.statementFileName = blob[0].name;
      this.tempCompanyStatementFile = blob;
    },
    getCompanySetting: function getCompanySetting(companyId) {
      var _this2 = this;

      var self = this;
      this.companySettingsLoading = true;
      var api = "https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2/".concat(companyId);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(api).then(function (res) {
        var _res$data, _res$data2, _res$data2$companycer, _res$data3, _res$data4, _res$data5;

        if (!res.data) return;
        self.companySettingsForm = Object.assign(res.data, {
          profilesubmissiondate: _this2.formatDate(res.data.profilesubmissiondate),
          companycertifications: !Array.isArray((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.companycertifications) ? ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$companycer = _res$data2.companycertifications) === null || _res$data2$companycer === void 0 ? void 0 : _res$data2$companycer.split(",")) || [] : res.data.companycertifications || [],
          additionalnaicscodes: res.data.additionalnaicscodes && !Array.isArray(res.data.additionalnaicscodes) ? res.data.additionalnaicscodes.split(",").filter(function (val) {
            return val.length;
          }).reduce(function (i, val) {
            i.push(val.replace(" ", ""));
            return i;
          }, []) : res.data.additionalnaicscodes || [],
          additionalpsccodes: (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.additionalpsccodes && !Array.isArray((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.additionalpsccodes) ? (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.additionalpsccodes.split(",").filter(function (val) {
            return val.length;
          }).reduce(function (i, val) {
            i.push(val.replace(" ", ""));
            return i;
          }, []) : res.data.additionalpsccodes || []
        });
        self.queryPscCodes("1");
        self.queryNaicsCodes("1");
        self.queryAdditionalPscCodes("1");
        self.queryAdditionalNaicsCodes("1").then(function () {
          self.companySettingsLoading = false;
        });
      });
    },
    getUpdatedCompanyFields: function getUpdatedCompanyFields(obj1, obj2) {
      var _this3 = this;

      var keys = this._.union(_.keys(obj1), this._.keys(obj2));

      return this._.filter(keys, function (key) {
        if (key === "companycertifications" || key === "additionalnaicscodes" || key === "additionalpsccodes") {
          return _this3._.differenceWith(obj2[key], obj1[key]).length;
        }

        return obj1[key] !== obj2[key];
      });
    },
    queryNaicsCodes: function queryNaicsCodes(val) {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=naics&search=".concat(val)).then(function (res) {
        // eslint-disable-next-line
        var i;

        for (i = 0; i < res.data.count; i++) {
          self.naicscodes.push(res.data.data[i].naicscode);
        }
      });
    },
    queryAdditionalNaicsCodes: function queryAdditionalNaicsCodes(val) {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=naics&search=".concat(val)).then(function (res) {
        // eslint-disable-next-line
        var i;

        for (i = 0; i < res.data.count; i++) {
          self.additionalNaicscodes.push(res.data.data[i].naicscode);
        }
      });
    },
    queryPscCodes: function queryPscCodes(val) {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=psc&search=".concat(val)).then(function (res) {
        var i;

        for (i = 0; i < res.data.count; i++) {
          self.psccodes.push(res.data.data[i].psccode);
        }
      });
    },
    queryAdditionalPscCodes: function queryAdditionalPscCodes(val) {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=psc&search=".concat(val)).then(function (res) {
        var i;

        for (i = 0; i < res.data.count; i++) {
          self.additionalPsccodes.push(res.data.data[i].psccode);
        }
      });
    },
    uploadLogo: function uploadLogo(company) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        var storageRef, logoRef, snackbar, logoUrl, _snackbar;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                storageRef = _this4.$firebase.storage().ref();
                logoRef = storageRef.child("companies/".concat(company, "/logo.jpg"));
                _context2.prev = 2;
                _context2.next = 5;
                return logoRef.put(_this4.tempCompanyLogoFile);

              case 5:
                _context2.next = 13;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);
                snackbar = {
                  active: true,
                  text: _context2.t0.message
                };

                _this4.$store.dispatch("triggerSnackbar", snackbar);

                setTimeout(function () {
                  var snackbar = {
                    active: false,
                    text: ""
                  };

                  _this4.$store.dispatch("triggerSnackbar", snackbar);
                }, 2000);
                return _context2.abrupt("return", null);

              case 13:
                _context2.prev = 13;
                _context2.next = 16;
                return storageRef.child("companies/".concat(company, "/logo.jpg")).getDownloadURL();

              case 16:
                logoUrl = _context2.sent;
                return _context2.abrupt("return", logoUrl);

              case 20:
                _context2.prev = 20;
                _context2.t1 = _context2["catch"](13);
                _snackbar = {
                  active: true,
                  text: "An error occurred while updating the settings.Please try again later."
                };

                _this4.$store.dispatch("triggerSnackbar", _snackbar);

                setTimeout(function () {
                  var snackbar = {
                    active: false,
                    text: ""
                  };

                  _this4.$store.dispatch("triggerSnackbar", snackbar);
                }, 3000);
                return _context2.abrupt("return", null);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 7], [13, 20]]);
      }))();
    },
    uploadStatement: function uploadStatement(company) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee3() {
        var storageRef, ext, type, statementRef, snackbar, statementUrl, _snackbar2;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                storageRef = _this5.$firebase.storage().ref();
                ext = ".pdf";
                type = _this5.tempCompanyStatementFile[0].type.split("/")[1].toLowerCase();

                if (type === "msword") {
                  ext = ".doc";
                }

                statementRef = storageRef.child("companies/".concat(company, "/statement").concat(ext));
                _context3.prev = 5;
                _context3.next = 8;
                return statementRef.put(_this5.tempCompanyStatementFile[0]);

              case 8:
                _context3.next = 16;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](5);
                snackbar = {
                  active: true,
                  text: "An error occurred while updating the settings.Please try again later."
                };

                _this5.$store.dispatch("triggerSnackbar", snackbar);

                setTimeout(function () {
                  var snackbar = {
                    active: false,
                    text: ""
                  };

                  _this5.$store.dispatch("triggerSnackbar", snackbar);
                }, 3000);
                return _context3.abrupt("return", null);

              case 16:
                _context3.prev = 16;
                _context3.next = 19;
                return storageRef.child("companies/".concat(company, "/statement").concat(ext)).getDownloadURL();

              case 19:
                statementUrl = _context3.sent;
                return _context3.abrupt("return", statementUrl);

              case 23:
                _context3.prev = 23;
                _context3.t1 = _context3["catch"](16);
                _snackbar2 = {
                  active: true,
                  text: _context3.t1.message
                };

                _this5.$store.dispatch("triggerSnackbar", _snackbar2);

                setTimeout(function () {
                  var snackbar = {
                    active: false,
                    text: ""
                  };

                  _this5.$store.dispatch("triggerSnackbar", snackbar);
                }, 2000);
                return _context3.abrupt("return", null);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 10], [16, 23]]);
      }))();
    }
  }
};

/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['id', 'show', 'deleteCompany'],
  methods: {
    close: function close() {
      this.$emit('closeModal', 'deleteCompanyModalDialog');
    }
  }
};

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CompanyView.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DeleteCompanyModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".import-company .input-group--select{margin-top:0!important}.form-layout .flex{padding:4px}.manual-add{height:400px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.manual-add .dot-border{width:700px;height:300px;padding:90px;background-color:#fbfbfc;border:1px dashed #d4dadf}.manual-add .dot-border.primary{color:#fff}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Company/ImportCompany.vue"],"names":[],"mappings":"AACA,qCACE,sBAA+B,CAChC,AACD,mBACE,WAAa,CACd,AACD,YACE,aAAc,AACd,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,wBACE,YAAa,AACb,aAAc,AACd,aAAc,AAId,yBAA0B,AAC1B,yBAA2B,CAC5B,AACD,gCACE,UAAY,CACb","file":"ImportCompany.vue","sourcesContent":["\n.import-company .input-group--select {\n  margin-top: initial !important;\n}\n.form-layout .flex {\n  padding: 4px;\n}\n.manual-add {\n  height: 400px;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.manual-add .dot-border {\n  width: 700px;\n  height: 300px;\n  padding: 90px;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  background-color: #fbfbfc;\n  border: 1px dashed #d4dadf;\n}\n.manual-add .dot-border.primary {\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".update-company .input-group--select{margin-top:0!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Company/UpdateCompany.vue"],"names":[],"mappings":"AACA,qCACE,sBAA+B,CAChC","file":"UpdateCompany.vue","sourcesContent":["\n.update-company .input-group--select {\n  margin-top: initial !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".profile_tabs .tabs__bar{background-color:#577194}.profile_tabs .tabs__bar .tabs__div{color:#fff}.profile-pic.round{position:relative;border-radius:100%;height:200px;border:2px solid #4a4a4a}.profile-pic.round>.profile-upload-overlay{width:200px;cursor:pointer;display:none;border-radius:100%;height:200px;position:absolute;top:0;background:rgba(62,58,58,.9)}.profile-upload-overlay div{margin-right:auto;margin-left:auto;width:90px;text-align:center;margin-top:80px;color:#fff}.profile-pic.round:hover>.profile-upload-overlay{display:block}.profile-pic.round:hover>.profile-upload-overlay.disabled{display:none}.profile-pic.round img{border-radius:100%;width:200px;height:200px}#company-settings .input-group--select{margin-top:0!important}#company-settings .input-group--text-field.input-group--multi-line textarea{height:67px!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/CompanyModal.vue"],"names":[],"mappings":"AACA,yBACE,wBAAoC,CACrC,AACD,oCACE,UAAY,CACb,AACD,mBACE,kBAAmB,AACnB,mBAAoB,AACpB,aAAc,AACd,wBAAsC,CACvC,AACD,2CACE,YAAa,AACb,eAAgB,AAChB,aAAc,AACd,mBAAoB,AACpB,aAAc,AACd,kBAAmB,AACnB,MAAO,AACP,4BAAkC,CACnC,AACD,4BACE,kBAAmB,AACnB,iBAAkB,AAClB,WAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACb,AACD,iDACE,aAAe,CAChB,AACD,0DACE,YAAc,CACf,AACD,uBACE,mBAAoB,AACpB,YAAa,AACb,YAAc,CACf,AACD,uCACE,sBAA2B,CAC5B,AACD,4EACE,qBAAwB,CACzB","file":"CompanyModal.vue","sourcesContent":["\n.profile_tabs .tabs__bar {\n  background-color: rgb(87, 113, 148);\n}\n.profile_tabs .tabs__bar .tabs__div {\n  color: #fff;\n}\n.profile-pic.round {\n  position: relative;\n  border-radius: 100%;\n  height: 200px;\n  border: 2px solid rgba(74, 74, 74, 1);\n}\n.profile-pic.round > .profile-upload-overlay {\n  width: 200px;\n  cursor: pointer;\n  display: none;\n  border-radius: 100%;\n  height: 200px;\n  position: absolute;\n  top: 0;\n  background: rgba(62, 58, 58, 0.9);\n}\n.profile-upload-overlay div {\n  margin-right: auto;\n  margin-left: auto;\n  width: 90px;\n  text-align: center;\n  margin-top: 80px;\n  color: #fff;\n}\n.profile-pic.round:hover > .profile-upload-overlay {\n  display: block;\n}\n.profile-pic.round:hover > .profile-upload-overlay.disabled {\n  display: none;\n}\n.profile-pic.round img {\n  border-radius: 100%;\n  width: 200px;\n  height: 200px;\n}\n#company-settings .input-group--select {\n  margin-top: 0px !important;\n}\n#company-settings .input-group--text-field.input-group--multi-line textarea {\n  height: 67px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1352);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("7577f834", content, true, {});

/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1380);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("51132298", content, true, {});

/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("a0826962", content, true, {});

/***/ }),

/***/ 1505:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("5038e179", content, true, {});

/***/ }),

/***/ 1519:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("e814ec7c", content, true, {});

/***/ }),

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1487)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1285),
  /* template */
  __webpack_require__(1695),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1505)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1286),
  /* template */
  __webpack_require__(1714),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1519)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1288),
  /* template */
  __webpack_require__(1735),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1469)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1289),
  /* template */
  __webpack_require__(1673),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), (_vm.isSelectedTab('update-company')) ? _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Update Company")])], 1), _vm._v(" "), _c('update-company')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('add-company')) ? _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Companies")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Add Company")])], 1), _vm._v(" "), _c('import-company')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1673:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Delete Company")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to this company delete?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteCompany(_vm.id)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card import-company"
  }, [_c('input', {
    ref: "csvImport",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function () { return _vm.handleFile('pick'); }
    }
  }), _vm._v(" "), _c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Add Company\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.results.length) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.btnLoading,
      "disabled": _vm.btnLoading
    },
    on: {
      "click": _vm.saveImported
    }
  }, [_vm._v("\n      Save\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.loadingCSV,
      "disabled": _vm.loadingCSV
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_vm._v("\n      Import CSV\n    ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": _vm.alert.type,
      "dismissible": ""
    },
    model: {
      value: (_vm.alert.status),
      callback: function($$v) {
        _vm.$set(_vm.alert, "status", $$v)
      },
      expression: "alert.status"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.alert.message) + "\n  ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.results.length) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.results,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companylegalname || 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companydescription || 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.emailaddress || 'N/A'))])]
      }
    }], null, false, 2879541083)
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card update-company"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Update Company\n    ")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.datasources,
      "label": "Select datasource",
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.datasource),
      callback: function($$v) {
        _vm.datasource = $$v
      },
      expression: "datasource"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "clear-icon": "",
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.companies,
      "loading": _vm.tableLoading,
      "pagination": _vm.tablePagination,
      "total-items": _vm.totalData,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.tablePagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v("\n          " + _vm._s(props.item.companylegalname) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(props.item.streetaddress) + "\n        ")]), _vm._v(" "), _c('td', [_c('v-menu', {
          attrs: {
            "bottom": "",
            "left": ""
          }
        }, [_c('v-btn', {
          staticClass: "darken-1",
          attrs: {
            "slot": "activator",
            "icon": "",
            "flat": "flat"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', {
          attrs: {
            "dark": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.viewCompany(props.item)
            }
          }
        }, [_vm._v("View")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
          attrs: {
            "dark": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editCompany(props.item)
            }
          }
        }, [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
          attrs: {
            "dark": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteCompany(props.item)
            }
          }
        }, [_vm._v("Delete")])], 1)], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('company-modal', {
    attrs: {
      "refreshTable": _vm.refreshTable,
      "show": _vm.companyModalDialog,
      "id": _vm.companyId,
      "readonly": _vm.companyModalReadonly
    },
    on: {
      "closeModal": _vm.closeModal
    }
  }), _vm._v(" "), _c('delete-company-modal', {
    attrs: {
      "show": _vm.deleteCompanyModalDialog,
      "id": _vm.companyId,
      "deleteCompany": _vm.deleteCompanyAction
    },
    on: {
      "closeModal": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1735:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Update Company")])], 1), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "id": "company-settings"
    }
  }, [(_vm.companySettingsLoading) ? _c('v-container', {
    staticStyle: {
      "min-height": "130px"
    },
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "py-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "primary"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.companySettingsLoading) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCompanySettings.apply(null, arguments)
      }
    }
  }, [_c('input', {
    ref: "companylogo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".jpeg, .png, .jpg"
    },
    on: {
      "change": _vm.setTempCompanyLogo
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "grid-list-md",
    staticStyle: {
      "max-width": "none",
      "padding": "20px 41px 0px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-layout', {
    staticClass: "pl-3 pt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('template', {
    slot: "activator"
  }, [_c('div', {
    staticClass: "profile-pic round"
  }, [(!_vm.companySettingsForm.companylogo) ? _c('img', {
    attrs: {
      "src": _vm.tempCompanyLogo || '/static/images/yourlogo.png',
      "alt": _vm.companySettingsForm.companylegalname
    }
  }) : _vm._e(), _vm._v(" "), (_vm.companySettingsForm.companylogo) ? _c('img', {
    attrs: {
      "src": _vm.tempCompanyLogo || _vm.companySettingsForm.companylogo,
      "alt": _vm.companySettingsForm.companylegalname
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "profile-upload-overlay",
    class: {
      disabled: _vm.readonly
    },
    attrs: {
      "justify-center": "",
      "row": "",
      "align-center": ""
    },
    on: {
      "click": function($event) {
        return _vm.pickFile('companylogo')
      }
    }
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-camera")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Upload image")])], 1)])], 1)]), _vm._v(" "), (!_vm.readonly) ? _c('span', [_vm._v("200px * 200px Recommended size")]) : _c('span', [_vm._v("View only")])], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md9": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Company Name",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.companylegalname),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companylegalname", $$v)
      },
      expression: "companySettingsForm.companylegalname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address Line 1",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.addressline1),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "addressline1", $$v)
      },
      expression: "companySettingsForm.addressline1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address Line 2",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.addressline2),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "addressline2", $$v)
      },
      expression: "companySettingsForm.addressline2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.city),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "city", $$v)
      },
      expression: "companySettingsForm.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Latitude",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.latitude),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "latitude", $$v)
      },
      expression: "companySettingsForm.latitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Longitude",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.longitude),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "longitude", $$v)
      },
      expression: "companySettingsForm.longitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "County",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.county),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "county", $$v)
      },
      expression: "companySettingsForm.county"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Zip",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "auto-grow": ""
    },
    model: {
      value: (_vm.companySettingsForm.zip),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "zip", $$v)
      },
      expression: "companySettingsForm.zip"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    staticClass: "pr-2 mt-0",
    attrs: {
      "items": [
        'AK',
        'AL',
        'AR',
        'AZ',
        'CA',
        'CO',
        'CT',
        'DE',
        'FL',
        'GA',
        'HI',
        'IA',
        'ID',
        'IL',
        'IN',
        'KS',
        'KY',
        'LA',
        'MA',
        'MD',
        'ME',
        'MI',
        'MN',
        'MO',
        'MS',
        'MT',
        'NC',
        'ND',
        'NE',
        'NH',
        'NJ',
        'NM',
        'NV',
        'NY',
        'OH',
        'OK',
        'OR',
        'PA',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VA',
        'VT',
        'WA',
        'WI',
        'WV',
        'WY' ],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "State:"
    },
    model: {
      value: (_vm.companySettingsForm.state),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "state", $$v)
      },
      expression: "companySettingsForm.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Company Website",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.businesswebsite),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "businesswebsite", $$v)
      },
      expression: "companySettingsForm.businesswebsite"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Public Contact Phone Number",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.phonenumber),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "phonenumber", $$v)
      },
      expression: "companySettingsForm.phonenumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Public Contact Email",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.email),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "email", $$v)
      },
      expression: "companySettingsForm.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(
    _vm.companySettingsForm.companyprimaryindustry !== 'Other'
  ) ? _c('v-select', {
    attrs: {
      "items": _vm.primaryIndustry,
      "label": "Primary Industry",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.companyprimaryindustry),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companyprimaryindustry", $$v)
      },
      expression: "companySettingsForm.companyprimaryindustry"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.companySettingsForm.companyprimaryindustry === 'Other'
  ) ? _c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Enter Primary Industry",
      "no-data-text": "Type to add data",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "placeholder": "Primary Industry"
    },
    model: {
      value: (_vm.companySettingsForm.companyprimaryindustry),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companyprimaryindustry", $$v)
      },
      expression: "companySettingsForm.companyprimaryindustry"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "grid-list-md",
    staticStyle: {
      "max-width": "none",
      "padding": "0px 41px",
      "padding-bottom": "20px"
    }
  }, [_c('v-layout', {
    staticClass: "pt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Company Description",
      "maxlength": "250",
      "counter": 250,
      "rules": [function (val) { return val.length <= 250 || 'Max 250 characters'; }],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.companydescription),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companydescription", $$v)
      },
      expression: "companySettingsForm.companydescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DUNS Number",
      "rules": [
        function () { return _vm.companySettingsForm.dunsnumber.length > 9 ?
        'You can only add 9 characters' :
        true; },
        function () { return _vm.companySettingsForm.dunsnumber.length < 9 ?
        'Must be of 9 digits' :
        true; } ],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.dunsnumber),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "dunsnumber", $$v)
      },
      expression: "companySettingsForm.dunsnumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cage Code",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.cagecode),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "cagecode", $$v)
      },
      expression: "companySettingsForm.cagecode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Yes', 'No'],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Federal Contractor?"
    },
    model: {
      value: (_vm.companySettingsForm.fedcontractor),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "fedcontractor", $$v)
      },
      expression: "companySettingsForm.fedcontractor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Federal Contractor Type",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.fedcontractortype),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "fedcontractortype", $$v)
      },
      expression: "companySettingsForm.fedcontractortype"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.naicscodes,
      "label": "Primary NAICS Code",
      "no-data-text": "Type to add data",
      "cache-items": "",
      "search-input": _vm.naicsSearch,
      "autocomplete": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    on: {
      "update:searchInput": function($event) {
        _vm.naicsSearch = $event
      },
      "update:search-input": function($event) {
        _vm.naicsSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.primarynaicscode),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "primarynaicscode", $$v)
      },
      expression: "companySettingsForm.primarynaicscode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.additionalNaicscodes,
      "no-data-text": "Type to add data",
      "search-input": _vm.additionalNaicsSearch,
      "autocomplete": "",
      "rules": [
        function () { return _vm.companySettingsForm.additionalnaicscodes.length > 5 ?
        'You can only add five codes' :
        true; } ],
      "multiple": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Additional NAICS Codes"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.additionalNaicsSearch = $event
      },
      "update:search-input": function($event) {
        _vm.additionalNaicsSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.additionalnaicscodes),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "additionalnaicscodes", $$v)
      },
      expression: "companySettingsForm.additionalnaicscodes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.psccodes,
      "label": "Primary PSC Code",
      "cache-items": "",
      "no-data-text": "Type to add data",
      "search-input": _vm.pscSearch,
      "autocomplete": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    on: {
      "update:searchInput": function($event) {
        _vm.pscSearch = $event
      },
      "update:search-input": function($event) {
        _vm.pscSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.primarypsccode),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "primarypsccode", $$v)
      },
      expression: "companySettingsForm.primarypsccode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.additionalPsccodes,
      "no-data-text": "Type to add data",
      "search-input": _vm.additionalPscSearch,
      "autocomplete": "",
      "cache-items": "",
      "multiple": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Additional PSC Codes"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.additionalPscSearch = $event
      },
      "update:search-input": function($event) {
        _vm.additionalPscSearch = $event
      }
    },
    model: {
      value: (_vm.companySettingsForm.additionalpsccodes),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "additionalpsccodes", $$v)
      },
      expression: "companySettingsForm.additionalpsccodes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "items": _vm.certifications,
      "multiple": "",
      "cache-items": "",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly,
      "label": "Company Certifications"
    },
    model: {
      value: (_vm.companySettingsForm.companycertifications),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "companycertifications", $$v)
      },
      expression: "companySettingsForm.companycertifications"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'None',
        'TOP SECRET',
        'SECRET',
        'CONFIDENTIAL',
        'FACILITY',
        'Q Clearance',
        'L Clearance' ],
      "label": "Security Clearance",
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.securityclearance),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "securityclearance", $$v)
      },
      expression: "companySettingsForm.securityclearance"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Specialties",
      "maxlength": "250",
      "height": 80,
      "counter": 250,
      "rules": [function (val) { return val.length <= 250 || 'Max 250 characters'; }],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.specialties),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "specialties", $$v)
      },
      expression: "companySettingsForm.specialties"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-align-left",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": "Capabilities",
      "maxlength": "250",
      "height": 80,
      "counter": 250,
      "rules": [function (val) { return val.length <= 250 || 'Max 250 characters'; }],
      "disabled": _vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.companySettingsForm.capabilities),
      callback: function($$v) {
        _vm.$set(_vm.companySettingsForm, "capabilities", $$v)
      },
      expression: "companySettingsForm.capabilities"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-align-left": ""
    }
  }, [_c('input', {
    ref: "companystatement",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accept": ".docx,.doc,.pdf",
      "type": "file"
    },
    on: {
      "change": _vm.setTempCompanyStatement
    }
  }), _vm._v(" "), (_vm.companySettingsForm.capabilitiesstatement.length) ? _c('v-btn', {
    staticStyle: {
      "margin": "0px 10px 0px 0px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "href": _vm.companySettingsForm.capabilitiesstatement,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": "/static/img/my-cap-stat.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin": "0px 10px 0px 0px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "disabled": _vm.readonly,
      "label": "Upload",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pickFile('companystatement')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": "/static/img/upload-icon.png"
    }
  })]), _vm._v("\n              " + _vm._s(_vm.statementFileName) + "\n            ")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-4": ""
    }
  }, [_c('v-layout', [_c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "type": "submit",
      "dark": "",
      "disabled": _vm.readonly,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                  Update\n                  "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1441)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1287),
  /* template */
  __webpack_require__(1639),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060504ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [{
        icon: '',
        text: 'Home',
        link: '/admin/settings/home'
      }, {
        icon: '',
        text: 'Settings',
        link: '/admin/settings/pages',
        children: [{
          icon: '',
          text: 'General Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'general-settings'
          }
        }, {
          icon: '',
          text: 'Email Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'email-settings'
          }
        }, {
          icon: '',
          text: 'Directory',
          link: '/admin/settings/pages',
          query: {
            page: 'directory'
          }
        }, {
          icon: '',
          text: 'Resources',
          link: '/admin/settings/pages',
          query: {
            page: 'resources'
          }
        }, {
          icon: '',
          text: 'Opportunities',
          link: '/admin/settings/pages',
          query: {
            page: 'opportunities'
          }
        }, {
          icon: '',
          text: 'History',
          link: '/admin/settings/pages',
          query: {
            page: 'history'
          }
        }, {
          icon: '',
          text: 'DoD Contract Analytics',
          link: '/admin/settings/pages',
          query: {
            page: 'dod-contract-analytics'
          }
        }, {
          icon: '',
          text: 'Bid Alerts',
          link: '/admin/settings/pages',
          query: {
            page: 'bid_alerts'
          }
        }, {
          icon: '',
          text: 'Questionnaire',
          link: '/admin/settings/pages',
          query: {
            page: 'questionnaire'
          }
        }, {
          icon: '',
          text: 'Favorites',
          link: '/admin/settings/pages',
          query: {
            page: 'favorites'
          }
        }, {
          icon: '',
          text: 'Tracking',
          link: '/admin/settings/pages',
          query: {
            page: 'tracking'
          }
        }]
      }, {
        icon: '',
        text: 'Users',
        link: '/admin/settings/users',
        children: [{
          icon: '',
          text: 'Manage Users',
          link: '/admin/settings/users',
          query: {
            page: 'manage-users'
          }
        }, {
          icon: '',
          text: 'Usage Tracking',
          link: '/admin/settings/users',
          query: {
            page: 'usage-tracking'
          }
        }, {
          icon: '',
          text: 'Default Chat Contact',
          link: '/admin/settings/users',
          query: {
            page: 'default-chat-contact'
          }
        }]
      }, {
        icon: '',
        text: 'Access',
        link: '/admin/settings/priviledges'
      }, {
        icon: '',
        text: 'Resources',
        link: '/admin/resources/all'
      }, {
        icon: '',
        text: 'Companies',
        link: '/admin/companies',
        children: [{
          icon: '',
          text: 'Update Company',
          link: '/admin/companies/update-company'
        }, {
          icon: '',
          text: 'Add Company',
          link: '/admin/companies/add-company'
        }]
      }, {
        icon: '',
        text: 'Requests',
        link: '/admin/settings/requests',
        children: [{
          icon: '',
          text: 'Activity Stream',
          link: '/admin/settings/requests',
          query: {
            page: 'activity'
          }
        }, {
          icon: '',
          text: 'Events',
          link: '/admin/settings/requests',
          query: {
            page: 'events'
          }
        }, {
          icon: '',
          text: 'Company Submission',
          link: '/admin/settings/requests',
          query: {
            page: 'companies'
          }
        } // {
        //   icon: '',
        //   text: 'Group Post',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'groups'
        //   }
        // },
        // {
        //   icon: '',
        //   text: 'Group Events',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'group-events'
        //   }
        // }
        ]
      }, {
        icon: '',
        text: 'Feedback/Support',
        link: '/admin/settings/support',
        children: [{
          text: 'Feedback',
          link: '/admin/settings/support',
          query: {
            page: 'feedback'
          }
        }, {
          text: 'Help Requests',
          link: '/admin/settings/support',
          query: {
            page: 'help-requests'
          }
        }]
      }, {
        icon: '',
        text: 'Admin Tutorials',
        link: '/admin/settings/tutorials',
        children: [{
          text: 'All Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'all'
          }
        }, {
          text: 'Manage Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'manage'
          }
        }]
      }]
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    checkUserRole: function checkUserRole() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr, fb, user, alert;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                usr = _this.$store.getters.getUserDetails;
                fb = _this.$firebase.database().ref();
                _context.next = 4;
                return fb.child('users/' + usr.uid.toString()).once('value');

              case 4:
                user = _context.sent;

                if (user.role !== 1) {
                  alert = {
                    ative: true,
                    header: 'Access denied',
                    text: "You don't have access on this page",
                    okText: 'Ok',
                    cancelText: ''
                  };

                  _this.$store.dispatch('triggerAlert', alert);

                  _this.$router.push('/user/feed');
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isOpen: function isOpen(rootPath) {
      return this.$route.fullPath.indexOf(rootPath) > -1;
    }
  }
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebar-menu[data-v-060504ef]{top:55px}.list__tile--active[data-v-060504ef],.list__tile--active[data-v-060504ef]:hover{background-color:rgba(0,0,0,.1)!important}.menu_list_data[data-v-060504ef]{width:100%}.menu_list_data li[data-v-060504ef]{margin-bottom:12px;padding-right:20px}.menu_list_item_data[data-v-060504ef]{font-size:16px}.list__group i[data-v-060504ef],.list__tile i[data-v-060504ef]{color:#a2a2a2}.list__tile__action[data-v-060504ef]{min-width:30px}.list__group__header--active[data-v-060504ef],.list__group__items[data-v-060504ef]{background-color:rgba(0,0,0,.4)}.list[data-v-060504ef]{background:transparent!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/AdminSideBar.vue"],"names":[],"mappings":"AACA,+BACE,QAAU,CACX,AAID,gFACE,yCAAgD,CACjD,AACD,iCACE,UAAY,CACb,AACD,oCACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,sCACE,cAAgB,CACjB,AACD,+DACE,aAAe,CAChB,AACD,qCACE,cAAgB,CACjB,AAID,mFACE,+BAAqC,CACtC,AACD,uBACE,gCAAmC,CACpC","file":"AdminSideBar.vue","sourcesContent":["\n.sidebar-menu[data-v-060504ef] {\n  top: 55px;\n}\n.list__tile--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.list__tile--active[data-v-060504ef]:hover {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.menu_list_data[data-v-060504ef] {\n  width: 100%;\n}\n.menu_list_data li[data-v-060504ef] {\n  margin-bottom: 12px;\n  padding-right: 20px;\n}\n.menu_list_item_data[data-v-060504ef] {\n  font-size: 16px;\n}\n.list__group i[data-v-060504ef], .list__tile i[data-v-060504ef] {\n  color: #a2a2a2;\n}\n.list__tile__action[data-v-060504ef] {\n  min-width: 30px;\n}\n.list__group__items[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list__group__header--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list[data-v-060504ef] {\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("91f344b8", content, true, {});

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "sidebar-menu",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "dark": "",
      "fixed": "",
      "value": true,
      "mobile-break-point": 768,
      "clipped": true
    }
  }, [_c('v-list', {
    staticClass: "menu_list_data",
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return (item.children) ? _c('v-list-group', {
      key: i,
      attrs: {
        "value": _vm.isOpen(item.link)
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "color": "grey"
      },
      slot: "activator"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(sub_item, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "router": "",
          "to": sub_item.query ? ((sub_item.link) + "/" + (sub_item.query.page)) : ("" + (sub_item.link))
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        staticClass: "menu_list_item_data",
        attrs: {
          "color": "white"
        }
      }, [_vm._v(_vm._s(sub_item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "white--text menu_list_item_data"
      }, [_vm._v("\n            " + _vm._s(sub_item.text) + "\n          ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.355a32e542ea86ee75ff.js